<template>
<v-carousel hide-delimiters show-arrows-on-hover :show-arrows="contests.length > 1" cycle prev-icon="fa-angle-left" next-icon="fa-angle-right" :height="135">

  <v-carousel-item v-for="(contest,i) in contests" :key="i" :style="gradientStyle(contest.color_1,contest.color_2)" :to="`/contests/${contest.id}/${contest.slug}`">

    <v-container>
      <v-row align="center" justify="center">
        <v-col cols="4" class="text-right">
          <div class="" id="slider-mobile" :style="`background-image:url(${contest.brand_logo})`">
          </div>
        </v-col>
        <v-col cols="8" class="text-left">
          <h5 class=" grey--text text--lighten-2">{{contest.title_mobile}}</h5>
          <h4 class=" white--text">{{contest.description_mobile | limit_50}}</h4>
        </v-col>
      </v-row>
    </v-container>


  </v-carousel-item>

</v-carousel>
</template>
<script>
export default {
  name: "",
  props: ['contests'],
  computed: {

  },
  methods: {
    gradientStyle(color_1, color_2) {
      return `background: ${color_1};background: -webkit-linear-gradient(to right, ${color_1}, ${color_2});background: linear-gradient(to right, ${color_1}, ${color_2});`
    }
  },
  data: () => ({

  })
}
</script>
<style lang="scss" scoped>
#slider-mobile {
    width: 100%;
    height: 90px;
    background-size: contain;
    background-position: center;
}
.gradient-bg {
    background: #232526;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #414345, #232526);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #414345, #232526);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

}
.headerbox {
    padding-top: 70px;
    padding-bottom: 70px;

    position: relative;
}
.headerbox::before {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: 100%;
    height: 85%;
    background-color: #fff;
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 200px;
    -webkit-box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.16);
    box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.16);

}
</style>
